// Client-side prefilter for folder imports — the same rules the server's curation
// heuristics apply (diwa/trove/bulk.py), run BEFORE anything leaves the browser so a
// 47k-file tree becomes a small manifest, not an upload.

export const PROSE_EXTENSIONS = ['.md', '.markdown', '.txt']

export const IGNORED_DIRS = new Set([
  'node_modules', '.git', '.hg', '.svn', 'dist', 'build', 'out', 'target',
  '__pycache__', '.venv', 'venv', '.obsidian', '.idea', '.vscode', '.next',
  '.cache', 'coverage', '.pytest_cache', '.mypy_cache', '.ruff_cache',
])

/** Mirrors the server's /trove/import content cap with headroom. */
export const MAX_FILE_BYTES = 380_000

export interface FolderFile {
  path: string
  size: number
}

/** The server's ImportRequest.filename cap — longer paths would 422 mid-run. */
export const MAX_PATH_CHARS = 300

export function isImportable(f: FolderFile): boolean {
  if (f.path.length > MAX_PATH_CHARS) return false
  const lower = f.path.toLowerCase()
  if (!PROSE_EXTENSIONS.some((ext) => lower.endsWith(ext))) return false
  const parts = f.path.split('/')
  const dirs = parts.slice(0, -1)
  if (dirs.some((d) => IGNORED_DIRS.has(d) || (d.startsWith('.') && d !== '.'))) return false
  if (f.size > MAX_FILE_BYTES) return false
  return true
}

/** Prefilter a folder manifest; `ignored` counts what the rules dropped. */
export function filterImportable(files: FolderFile[]): { keep: FolderFile[]; ignored: number } {
  const keep = files.filter(isImportable)
  return { keep, ignored: files.length - keep.length }
}

/** Group selected paths by their top-level directory for the gate's review list. */
export function groupByTopDir(paths: string[]): Map<string, string[]> {
  const groups = new Map<string, string[]>()
  for (const p of paths) {
    const top = p.includes('/') ? p.split('/')[0] : '(root)'
    const list = groups.get(top)
    if (list) list.push(p)
    else groups.set(top, [p])
  }
  return groups
}
